import React from 'react';
import { Glyphicon, Button } from 'react-bootstrap'

class ActionButton extends React.Component {
    render () {
        return (
            <Button disabled={this.props.disabled} id={this.props.id} bsSize={this.props.bsSize} style={this.props.style} bsStyle={this.props.bsStyle} onClick={this.props.onClick} className="btn-block text-left"><Glyphicon glyph={this.props.icon} style={{marginRight: "5px"}} /> {this.props.children}</Button>
        )
    }
}

ActionButton.defaultProps = {
    icon: "play",
    bsStyle: "default",
    disabled: false,
    bsSize: "xsmall"
}

export default ActionButton


// WEBPACK FOOTER //
// ./src/fw/components/actionButton/ActionButton.js